import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useStyles, chargifyStyles } from '../checkoutDrawer.styles';
import { CHECKOUT_CHARGIFY_PANEL_ID } from '../useCheckoutDrawerState';

/*
 * Isolated subcomponent so that useEffect([], []) fires exactly when
 * #checkoutDrawerChargifyPanel is mounted — the same pattern as BillingChargifyForm.
 * This guarantees the div exists in the DOM before chargify.load() is called.
 */
function ChargifyPanel ({ formRef, form, initChargify }) {
    const classes = useStyles();

    useEffect(() => {
        initChargify(chargifyStyles);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <form ref={formRef} id="connectCheckoutForm" noValidate>
            <div id={CHECKOUT_CHARGIFY_PANEL_ID} className={classes.chargifyPanel} />
            <input type="hidden" data-chargify="email" value={form.email} onChange={() => {}} />
            <input type="hidden" data-chargify="firstName" value={form.firstName} onChange={() => {}} />
            <input type="hidden" data-chargify="lastName" value={form.lastName} onChange={() => {}} />
            <input type="hidden" data-chargify="address" value={form.address} onChange={() => {}} />
            <input type="hidden" data-chargify="address2" value={''} onChange={() => {}} />
            <input type="hidden" data-chargify="city" value={form.city} onChange={() => {}} />
            <input type="hidden" data-chargify="country" value={form.country} onChange={() => {}} />
            <input type="hidden" data-chargify="state" value={form.state} onChange={() => {}} />
            <input type="hidden" data-chargify="zip" value={form.zip} onChange={() => {}} />
        </form>
    );
}

ChargifyPanel.propTypes = {
    formRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any }),
    ]).isRequired,
    form: PropTypes.shape({
        email: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        address: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
    }).isRequired,
    initChargify: PropTypes.func.isRequired,
};

export default ChargifyPanel;
